import { Button, Fab } from '@mui/material';
import { styled } from '@mui/material/styles';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export const DeleteIconButton = styled(DeleteOutlineIcon)(({ theme }) => ({
  color: '#E53E3E',
  padding: theme.spacing(0.25),
  borderRadius: '50%',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0.5),
  },
  '&:hover': {
    backgroundColor: 'rgba(229, 62, 62, 0.05)',
  },
}));

export const SendMessageButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  minWidth: 0,
  width: 40,
  height: 40,
  padding: 0,
  borderRadius: '50%',
  transition: 'all 0.2s ease',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '&:hover': {
    backgroundColor: '#4A6FE8',
  },

  [theme.breakpoints.up('md')]: {
    width: 44,
    height: 44,
  },
}));

export const FabButton = styled(Fab)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 56,
  height: 56,
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: '#4A6FE8',
    transform: 'scale(1.05)',
  },
}));